import { render } from "./GM1Leukocytes.vue?vue&type=template&id=7e4c499a&scoped=true"
import script from "./GM1Leukocytes.vue?vue&type=script&lang=js"
export * from "./GM1Leukocytes.vue?vue&type=script&lang=js"

import "./GM1Leukocytes.vue?vue&type=style&index=0&id=7e4c499a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4c499a"]])

export default __exports__